import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import Breadcrumbs from '../components/Breadcrumbs'
import ProjectBoard from '../components/ProjectBoard'
import Seo from '../components/Seo'
import { getProject } from '../lib/storage'
import type { Project } from '../lib/storage'
import { useLocale, localizedHref } from '../i18n/locale'
import { t } from '../i18n/strings'

export default function ProjectPage() {
  const { id } = useParams<{ id: string }>()
  const navigate = useNavigate()
  const locale = useLocale()
  const tr = (k: string) => t(locale, k)
  const L = (en: string) => localizedHref(en, locale)
  const [project, setProject] = useState<Project | null>(null)
  const [loaded, setLoaded] = useState(false)

  useEffect(() => {
    if (!id) { setLoaded(true); return }
    getProject(id).then((p) => { setProject(p); setLoaded(true) })
  }, [id])

  if (!loaded) return null

  if (!project) {
    return (
      <div className="mx-auto max-w-3xl px-4 py-8">
        <p className="text-text-muted">{tr('projectpage.notFound')}</p>
        <button onClick={() => navigate(`${locale === 'fr' ? '/fr' : ''}/my-sheets`)} className="mt-4 text-sm text-brand-text hover:underline">
          {tr('projectpage.back')}
        </button>
      </div>
    )
  }

  return (
    <div className="px-4 py-6">
      <Seo
        title={`${project.name} — RenoSheets`}
        description={tr('projectpage.seoDesc')}
        path={`/my-sheets/project/${project.id}/`}
      />
      <Breadcrumbs
        items={[
          { name: tr('crumb.home'), href: L('/') },
          { name: tr('mysheets.h1'), href: L('/my-sheets/') },
          { name: project.name, href: `/my-sheets/project/${project.id}/` },
        ]}
      />
      <h1 className="text-2xl font-semibold text-text">{project.name}</h1>
      <div className="mt-5">
        <ProjectBoard projectId={project.id} />
      </div>
    </div>
  )
}
